<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Nomor Seri Faktur Pajak (E-NoFa)
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="openDetail" v-if="showList">Show Detail NSFP</b-button>
          <b-button variant="primary mr-1" @click="openList" v-if="showDetail">Show List Tgl.terbit</b-button>
          <!-- <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>-->
          <b-button variant="primary mr-1" @click="exportxls()" v-if="showDetail">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
      <b-card no-body v-if="showList">
        <!-- <template v-slot:header v-if="(filterNsfpHeaderShow=='Hide')">
        </template> -->
          <b-row v-if="(filterNsfpHeaderShow=='Hide')" class="mt-1"> 
            <b-col lg="7">
              <b-input-group >
                <b-input-group-prepend><span class="p-2">Tgl. Terbit</span></b-input-group-prepend>
                <b-form-input v-model="nsfpHeader.tgl1" type="date" ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">s.d</span></b-input-group-prepend>
                <b-form-input v-model="nsfpHeader.tgl2" type="date" ></b-form-input>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear</b-button>
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="primary" size="sm" class="ml-2" @click="filterNsfpHeaderShow='Show'" >Hide Filter</b-button>
                </b-input-group-append>
              </b-input-group>                      
            </b-col>          
          </b-row>
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="data"
          :fields="nsfpHeader.fields"
          show-empty
          @row-clicked="rowClicked"
          :filter="filterNsfpHeader"
          :filterIncludedFields="filterOnNsfpHeader"
          @filtered="onFilteredNsfpHeader"
        >
          <template v-slot:cell(lineno)="data">{{ data.index +1}}</template>

              <template v-slot:cell(tglterbit)="data">
                  {{ data.item.tglterbit | moment("DD-MMM-YYYY") }}
              </template>
              <template v-slot:cell(batasakhir)="data">
                  <span v-if="(data.item.batasakhir)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span>
              </template>

          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a
                href="javascript:void(0)"
                class="text-danger"
                @click="delConfirm(data.index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:cell(empty)="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="scope">
            <h4>{{ scope.emptyFilteredText }}</h4>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div class="ml-1">
              Showing {{(nsfpHeader.page - 1) * nsfpHeader.limit + 1}}
              to
              <span
                v-if="((nsfpHeader.page * nsfpHeader.limit)>nsfpHeader.total)"
              >{{nsfpHeader.total}}</span>
              <span v-else>{{nsfpHeader.page * nsfpHeader.limit}}</span>
              of {{nsfpHeader.total}} entries.
            </div>
          </b-col>
          <b-col cols="4" align="center">
            <span class="mr-1">limit per page :</span>
            <select v-model="nsfpHeader.limit" style="width:60px;">
              <option>10</option>
              <option>15</option>
              <option>20</option>
              <option>25</option>
              <option>30</option>
              <option>40</option>
              <option>50</option>
              <option>60</option>
              <option>70</option>
              <option>80</option>
              <option>90</option>
            </select>
            <b-form-checkbox
              v-model="filterNsfpHeaderShow"
              value="Hide"
              unchecked-value="Show"
              switch
              class="ml-2"
            >
              <b>{{ filterNsfpHeaderShow }}</b> Filter
            </b-form-checkbox>
          </b-col>
          <b-col cols="4">
            <b-pagination
              class="ml-1"
              align="right"
              :total-rows="nsfpHeader.total"
              :per-page="nsfpHeader.limit"
              v-model="nsfpHeader.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>

      <b-card v-if="showDetail">
          <b-input-group>
              <b-input-group-prepend><span class="p-2">Tgl. Terbit</span></b-input-group-prepend>
              <b-form-input v-model="nsfpHeader.selected.tglterbit" disabled type="date"></b-form-input>
              <b-input-group-prepend><span class="p-2">NSFP , dari</span></b-input-group-prepend>
              <b-form-input v-model="nsfpHeader.selected.nsfpawal" disabled></b-form-input>
              <b-input-group-prepend><span class="p-2">sampai</span></b-input-group-prepend>
              <b-form-input v-model="nsfpHeader.selected.nsfpakhir" disabled></b-form-input>
          </b-input-group>

        <b-card no-body v-if="(filterNsfpLineShow=='Hide')" class="mt-1">
          <template v-slot:header>
            <b-row>
              <b-col lg="3">
                <b-input-group size="sm" class="mt-1">
                  <b-input-group-prepend>
                    <span class="pt-1 mr-1">FILTER</span>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filterNsfpLine"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filterNsfpLine" @click="clearFilterNsfpLine">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-form-checkbox
                  v-model="filterNsfpLineShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                >
                  <b>{{ filterNsfpLineShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
              <b-col lg="9">
                <b-form-group
                  label="FILTER ON :"
                  label-cols-sm="1"
                  description="Leave all unchecked to filter on all data"
                  class="mb-0"
                >
                  <b-form-checkbox-group v-model="filterOnNsfpLine" class="mt-1">
                    <b-form-checkbox
                      v-for="(item,index) in nsfpLines.fields.filter(x=>x.filterable)"
                      :key="index"
                      :value="item.key"
                    >{{item.label}}</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </b-card>
        <b-table
          class="mb-0"
          ref="tableLine"
          outlined
          responsive
          striped
          hover
          bordered
          style="font-size:smaller;"
          :items="nsfpLines.items"
          :fields="nsfpLines.fields"
          :current-page="nsfpLines.page"
          :per-page="nsfpLines.limit"
          :sort-by.sync="nsfpLines.sortBy"
          :sort-desc.sync="nsfpLines.sortDesc" 
          :key="nsfpLines.page"
          show-empty
          :filter="filterNsfpLine"
          :filterIncludedFields="filterOnNsfpLine"
          @filtered="onFilteredNsfpLine"
        >
          <template v-slot:cell(lineno)="data">{{ data.index +1}}</template>
          <template v-slot:cell(tglfaktur)="data">
              <span v-if="(data.item.tglfaktur)">{{ data.item.tglfaktur | moment("DD-MMM-YYYY") }}</span>
          </template>

          <template v-slot:cell(pesanmanual)="data">
            <span v-if="data.item.pesanmanual==1">Dipesan</span>
          </template>

          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click="editNsfpLines(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a
                href="javascript:void(0)"
                class="text-danger"
                @click="delLineConfirm(data.index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:cell(empty)="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="scope">
            <h4>{{ scope.emptyFilteredText }}</h4>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div class="ml-1">
              Showing {{(nsfpLines.page - 1) * nsfpLines.limit + 1}}
              to
              <span
                v-if="((nsfpLines.page * nsfpLines.limit)>nsfpLines.total)"
              >{{nsfpLines.total}}</span>
              <span v-else>{{nsfpLines.page * nsfpLines.limit}}</span>
              of {{nsfpLines.total}} entries.
            </div>
          </b-col>
          <b-col cols="4" align="center">
            <span class="mr-1">limit per page :</span>
            <select v-model="nsfpLines.limit" style="width:60px;">
              <option>10</option>
              <option>15</option>
              <option>20</option>
              <option>25</option>
              <option>30</option>
              <option>40</option>
              <option>50</option>
              <option>60</option>
              <option>70</option>
              <option>80</option>
              <option>90</option>
            </select>
            <b-form-checkbox
              v-model="filterNsfpLineShow"
              value="Hide"
              unchecked-value="Show"
              switch
              class="ml-2"
            >
              <b>{{ filterNsfpLineShow }}</b> Filter
            </b-form-checkbox>
          </b-col>
          <b-col cols="4">
            <b-pagination
              class="ml-1"
              align="right"
              :total-rows="nsfpLines.total"
              :per-page="nsfpLines.limit"
              v-model="nsfpLines.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    
    </b-card>




    <b-modal
      v-model="showForm"
      header-bg-variant="primary"
      title="Form - Penambahan NSFP melalui e-Nofa "
      :centered="true"
      @ok="save"
    >
      <b-input-group>
        <b-input-group-prepend>
          <label>Tanggal Terbit</label>
        </b-input-group-prepend>
        <b-form-input v-model="frmhdr.tglterbit" type="date" :state="!$v.frmhdr.tglterbit.$error"></b-form-input>                                        
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Dari NSFP</label></b-input-group-prepend>
        <b-form-input v-model="frmhdr.nsfpawal" placeholder="nomor Awal" :state="!$v.frmhdr.nsfpawal.$error" maxlength="17"></b-form-input>                                        
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Sampai NSFP</label></b-input-group-prepend>
        <b-form-input v-model="frmhdr.nsfpakhir" placeholder="nomor Akhir" :state="!$v.frmhdr.nsfpakhir.$error" maxlength="17"></b-form-input>                                        
      </b-input-group>
    </b-modal>

    <b-modal
      v-model="showDetailFrm"
      header-bg-variant="primary"
      title="Detail Pemakaian NSFP"
      :centered="true"
      @ok="saveNsfpLines"
    >
      <b-input-group>
        <b-input-group-prepend>
          <label>Nomor Seri</label>
        </b-input-group-prepend>
        <b-form-input v-model="nsfpLinesObj.nomorsfp" :state="!$v.nsfpLinesObj.nomorsfp.$error" maxlength="10" readonly></b-form-input>
        <b-form-checkbox v-model="nsfpLinesObj.pesanmanual" :value="1" :unchecked-value="0"  class="ml-1 pt-2"> Pesan(input Manual)</b-form-checkbox>
      </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Nomor Invoice</label>
            </b-input-group-prepend>
            <b-form-input v-model="nsfpLinesObj.nomorinv" ></b-form-input>
          </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label>Tanggal Faktur</label>
        </b-input-group-prepend>
        <b-form-input v-model="nsfpLinesObj.tglfaktur" type="date" :state="!$v.nsfpLinesObj.tglfaktur.$error"></b-form-input>                                        
      </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Kode Transaksi</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="nsfpLinesObj.kodetrx" :state="!$v.nsfpLinesObj.kodetrx.$error"
              :plain="true"
              :options="kodetransaksi"
            ></b-form-select>
          </b-input-group>

      <b-input-group>
        <b-input-group-prepend>
          <label>Kode Status</label>
        </b-input-group-prepend>
        <b-form-radio-group v-model="nsfpLinesObj.kodestatus" class="mt-2" >
          <b-form-radio :value="0">0. Normal</b-form-radio>
          <b-form-radio :value="1">1. Penggantian</b-form-radio>
        </b-form-radio-group>
      </b-input-group>
    </b-modal>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="del">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <b-modal v-model="showDelLineConfirm" title="Delete Record?" :centered="true" @ok="delNsfpLines">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>



<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import nsfp from "../../apis/ppnkeluarnsfp";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmhdr: {
      tglterbit: { required },
      nsfpawal: { required },
      nsfpakhir: { required }
    },
    nsfpLinesObj: {
      nomorsfp: { required },
      tglfaktur: {
        required: function() {
          if ((this.nsfpLinesObj.nomorinv || '') == '') {
            return true;
          } else if (this.nsfpLinesObj.tglfaktur) {
            return false;
          } else return true;
        },
      },
      kodetrx: {
        required: function() {
          if ((this.nsfpLinesObj.nomorinv || '') == '') {
            return true;
          } else if (this.nsfpLinesObj.kodetrx) {
            return false;
          } else return true;
        }
      }
    }
  },
  data() {
    return {
      filter: { nomorsfp: "", tgl1: "", tgl2: "", tabIndex: 1 },
      isLoading: false,
      saveEnabled: true,
      showList: true,
      showForm: false,
      showDetail: false,
      showDetailFrm: false,
      showDelConfirm: false,
      showDelLineConfirm:false,
      reportUrl: null,
      showReport: false,
      YesNo: [
        { value: 1, text: "YES" },
        { value: 0, text: "NO" }
      ],
      kodetransaksi: [{value :'01',text:'01.Penyerahan Barang Kena Pajak (BKP) atau Jasa Kena Pajak (JKP) yang PPNnya terutang dipungut oleh PKP penjual.'},
                      {value :'02',text:'02.Penyerahan BKP atau JKP kepada pemungut PPN bendahara pemerintah yang PPNnya dipungut oleh bendahara pemerintah.'},
                      {value :'03',text:'03.Penyerahan BPK/JKP kepada pemungut PPN lainnya yang PPNnya dipungut oleh pemungut PPN lainnya.'},
                      {value :'04',text:'04.Penyerahan BPK/JKP yang menggunakan DPP nilai lain yang PPNnya dipungut oleh PKP penjual yang melakukan penyerahan.'},
                      {value :'05',text:'05.Tidak digunakan'},
                      {value :'06',text:'06.Penyerahan lain yang PPN-nya dipungut oleh PKP penjual yang melakukan penyerahan BPK/JKP, dan penyerahan kepada orang pribadi pemegang paspor luar negeri.'},
                      {value :'07',text:'07.Penyerahan BKP/JKP yang mendapat fasilitas PPN Tidak Dipungut atau Ditanggung Pemerintah (DTP).'},
                      {value :'08',text:'08.Penyerahan BKP/JKP yang mendapat fasilitas dibebaskan dari pengenaan PPN.'},
                      {value :'09',text:'09.Penyerahan aktiva Pasal 16 D yang PPN-nya dpungut oleh PKP penjual.'}, {value:'', text:''}],
      frmhdr: {
        tglterbit: "",
        nsfpawal: "",
        nsfpakhir: ""
      },
      filterNsfpHeaderShow: "Hide",
      nsfpHeader: {
        items: [],
        selected: {},
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
        fields: [
          {
            key: "lineno",
            label: "No.",
            thStyle: "width:40px"
          },
          {
            key: "tglterbit",
            label: "Tgl.Terbit",
            sortable: true
          },
          {
            key: "nsfpawal",
            label: "NSFP Awal",
            sortable: true,
            filterable: true
          },
          {
            key: "nsfpakhir",
            label: "NSFP Akhir",
            sortable: true,
            filterable: true
          },
          {
            key: "tglakhir",
            label: "Batas Akhir",
            filterable: true
          },
          {
            key: "nsfptotal",
            label: "Total NSFP",
            thStyle: "width:60px",
            sortable: true,
            filterable: true
          },
          {
            key: "nsfpterpakai",
            label: "Terpakai",
            thStyle: "width:40px",
            sortable: true,
            filterable: true
          },
          {
            key: "nsfpterpesan",
            label: "Dipesan (untuk dipakai Manual)",
            thStyle: "width:130px",
            sortable: true,
            filterable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
            tdClass: "text-center"
          }
        ]
      },
      filterOnNsfpHeader: [],
      filterNsfpHeader: null,
      // start nsfpline
      nsfpLinesObj: {
        nomorsfp: "",
        nomorinv: "",
        tglfaktur: "",
        kodestatus: 0,
        kodetrx: "01",
        pesanmanual: 0,
      },
      filterNsfpLineShow: "Show",
      nsfpLines: {
        items: [],
        fields : [
        {
          key: "lineno",
          label: "No.",
          thStyle: "width:40px"
        },
        {
          key: "nomorsfp",
          label: "Nomor Seri",
          sortable: true,
          filterable: true
        },
        {
          key: "pesanmanual",
          label: "Pesan Manual",
          thStyle: "width:40px",
          sortable: true,
          filterable: true
        },
        {
          key: "nomorinv",
          label: "Nomor Invoice",
          sortable: true,
          filterable: true
        },
        {
          key: "tglfaktur",
          label: "Tgl.Faktur",
          sortable: true,
          filterable: true
        },
        {
          key: "kodetrx",
          label: "Transaksi",
          thStyle: "width:40px",
          sortable: true,
          filterable: true
        },
        {
          key: "kodestatus",
          label: "Pengganti",
          thStyle: "width:40px",
          sortable: true,
          filterable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:40px",
          sortable: true
      }],
        selected: {},
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        nsfphdrkey:'-'
      },
      filterOnNsfpLine: [],
      filterNsfpLine: null,
      ttlTerpakai: 0,
      ttlTerpesan:0
    };
  },
  components: { Loading },
  computed: {
    invalidNsfpLines() {
      this.$v.nsfpLinesObj.$touch();
      return this.$v.nsfpLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.frmhdr.$touch();
      return this.$v.frmhdr.$invalid;
    }
  },
  created: async function() {
    this.frmhdr.tglterbit = moment();
    // const d = await nsfp.list();
    // this.nsfpHeader.items = d || [];
  },
  methods: {
    data: async function(ctx) {
      this.nsfpHeader.sortDir = this.nsfpHeader.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await nsfp.list(this.nsfpHeader);      
      this.nsfpHeader.items=list;
      this.isLoading=false;
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.nsfpHeader.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.nsfpHeader.tgl1=  '';
        this.nsfpHeader.tgl2=  '';
        this.$forceUpdate();
    },    
    onFilteredNsfpHeader(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.nsfpHeader.total = filteredItems.length;
      this.nsfpHeader.page = 1;
    },
    clearFilterNsfpHeader() {
      this.filterOnNsfpHeader = [];
      this.filterNsfpHeader = "";
    },
    onFilteredNsfpLine(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.nsfpLines.total = filteredItems.length;
      this.nsfpLines.page = 1;
    },
    clearFilterNsfpLine() {
      this.filterOnNsfpLine = [];
      this.filterNsfpLine = "";
    },
    rowClicked(record, index) {
      if (this.nsfpHeader.selected && this.nsfpHeader.selected._rowVariant) {
        delete this.nsfpHeader.selected._rowVariant;
      }
      this.nsfpHeader.selected = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    openDetail: async function() {
      if (this.nsfpHeader.items.length == 1)
        this.nsfpHeader.selected = this.nsfpHeader.items[0];
      if (this.nsfpHeader.selected.nsfphdrkey) {
        try {
          this.isLoading = true;
          // const model=this.nsfpLines.items[index];
          const listtrx = await nsfp.detail(this.nsfpHeader.selected);
          this.nsfpLines.items = listtrx;
          this.nsfpLines.total = listtrx.length;
          this.calcDtlNsfp();
          this.isLoading = false;
          this.showList = false;
          this.showDetail = true;
        } catch (error) {
          console.log("save : ", error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);

          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Open/Show!");
      }
    },
    async openList() {
      const d = await nsfp.list();
      this.nsfpHeader.items = d || [];
      this.showList = true;
      this.showDetail = false;
    },
    addNsfpLines: function() {
      // if (!this.nsfpLinesObj.tanggal) {
      //   this.nsfpLinesObj.tanggal = moment();
      // }
      this.showDetailFrm = true;
    },
    editNsfpLines: function(obj) {
      this.nsfpLines.selected = obj;
      // for (var key in this.nsfpLinesObj) {
      //   this.nsfpLinesObj[key] = "";
      // }
      for (var key in obj) {
        this.nsfpLinesObj[key] = obj[key];
      }
      this.nsfpLinesObj.tglfaktur = (this.nsfpLinesObj.tglfaktur) ? moment(this.nsfpLinesObj.tglfaktur).format('YYYY-MM-DD') : '';
      this.nsfpLinesObj.pesanmanual = this.nsfpLinesObj.pesanmanual || 0;
      this.nsfpLinesObj.kodestatus = this.nsfpLinesObj.kodestatus || 0;
      this.showDetailFrm = true;
    },
    delLineConfirm(index) {
      this.nsfpLines.index = index;
      // this.nsfpHeader.selected=this.nsfpHeader.items[index];
      this.showDelLineConfirm = true;
    },
    delNsfpLines: async function() {
      try {
        this.isLoading = true;
        const index = this.nsfpLines.index;
        const model = this.nsfpLines.items[index];
        await nsfp.removedetail(model);
        if (index > -1) {
          this.nsfpLines.items.splice(index, 1);
        }
        this.nsfpLines.total = this.nsfpLines.items.length;
        this.calcDtlNsfp();
        this.isLoading = false;
      } catch (error) {
        console.log("save : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
        this.saveEnabled = true;
      }
    },
    saveNsfpLines: async function(evt) {
      evt.preventDefault();
      if (this.invalidNsfpLines) {
        console.log("validation : ", this.$v.nsfpLinesObj);
        console.log("model obj : ", this.nsfpLinesObj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        if (!this.saveEnabled) {
          return;
        }
        this.saveEnabled = false;
        try {
          const model = {};
          this.nsfpLinesObj.tglfaktur = (this.nsfpLinesObj.tglfaktur) ? moment(this.nsfpLinesObj.tglfaktur).format("YYYY-MM-DD"):'';
          this.nsfpLinesObj.nsfphdrkey = this.nsfpHeader.selected.nsfphdrkey;
          for (var key in this.nsfpLinesObj) {
            model[key] = this.nsfpLinesObj[key];
          }
          const newTrx = await nsfp.savedetail(model);
          if (!model.nsfplinekey) {
            model.nsfplinekey = newTrx.nsfplinekey;
            this.nsfpLines.items.push(model);
            this.nsfpLines.total = this.nsfpLines.items.length;
          } else {
            for (var key in model) {
              this.nsfpLines.selected[key] = model[key];
            }
          }
          this.nsfpLines.items.sort(function(a, b) {
            var dateA = new Date(a.nomorsfp),
              dateB = new Date(b.nomorsfp);
            return dateA - dateB;
          });

          for (var key in this.nsfpLinesObj) {
            this.nsfpLinesObj[key] = "";
          }
          this.nsfpLinesObj.nsfplinekey = "";
          this.nsfpLinesObj.pesanmanual = 0;
          this.nsfpLinesObj.nomorinv = "";
          this.nsfpLinesObj.kodetrx = "01";
          this.nsfpLinesObj.kodestatus= 0;

          this.calcDtlNsfp();
          nsfp.updateTotal({
            nsfphdrkey: this.nsfpHeader.selected.nsfphdrkey,
            ttlTerpakai: this.ttlTerpakai,
            ttlTerpesan: this.ttlTerpesan
          });
          this.showDetailFrm = false;
          this.saveEnabled = true;
        } catch (error) {
          this.saveEnabled = true;
          console.log("error : ", error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    calcDtlNsfp: function() {
      let ttlTerpakai = 0;
      let ttlTerpesan = 0;
      this.nsfpLines.items.forEach(function(item) {
        if (item.nomorinv) {
          ttlTerpakai += 1;
        }
        if (item.pesanmanual) {
          ttlTerpesan += 1;
        }
      });
      this.ttlTerpakai=ttlTerpakai;
      this.ttlTerpesan=ttlTerpesan;
    },
    add: function() {
      for (var key in this.frmhdr) {
        this.frmhdr[key] = "";
      }
      this.frmhdr.nsfphdrkey = "";
      this.frmhdr.tglterbit=moment().format('YYYY-MM-DD');
      this.showForm = true;
    },
    edit: function(obj) {
      this.nsfpHeader.selected = obj;
      for (var key in this.frmhdr) {
        this.frmhdr[key] = "";
      }
      for (var key in obj) {
        this.frmhdr[key] = obj[key];
      }
      this.showForm = true;
    },
    delConfirm(index) {
      this.nsfpHeader.index = index;
      // this.nsfpHeader.selected=this.nsfpHeader.items[index];
      this.showDelConfirm = true;
    },
    del: async function() {
      try {
        let index = this.nsfpHeader.index;
        this.isLoading = true;
        const model = this.nsfpHeader.items[index];
        await nsfp.remove(model);
        if (index > -1) {
          this.nsfpHeader.items.splice(index, 1);
        }
        this.nsfpHeader.total = this.nsfpHeader.items.length;
        this.isLoading = false;
      } catch (error) {
        console.log("save : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
        this.saveEnabled = true;
      }
    },

    save: async function(evt) {
      evt.preventDefault();
      this.isLoading=true;      
      if (this.invalidModel) {
        console.log("validation : ", this.$v.frmhdr);
        console.log("model obj : ", this.frmhdr);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading=false;      
      } else {
        if (!this.saveEnabled) {
          return;
        }
        this.saveEnabled = false;
        try {
          const newTrx = await nsfp.save(this.frmhdr);
          if (!this.frmhdr.nsfphdrkey) {
            this.frmhdr.nsfphdrkey = newTrx.nsfphdrkey;
            this.nsfpHeader.items.push(this.frmhdr);
            this.nsfpHeader.total = this.nsfpHeader.items.length;
          } else {
            for (var key in this.frmhdr) {
              this.nsfpHeader.selected[key] = this.frmhdr[key];
            }
          }

          this.isLoading=false;      
          this.showForm = false;
          this.saveEnabled = true;
        } catch (error) {
          this.saveEnabled = true;
          this.isLoading=false;      
          console.log("error : ", error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
        }
      }
    },

    exportxls: async function() {
      if (!this.nsfpHeader.selected) {
        console.log("model obj : ", this.nsfpHeader.selected);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await nsfp.exportxls(this.nsfpHeader.selected);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
      // router.push({ name: "app.modules" });
    }

  }
};
</script>
